import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE_AGENT } from '@utils/helpers'

const settingRoutes = {
  path: 'setting',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.setting'),
  },
  children: [
    {
      path: '',
      name: 'setting',
      component: () => lazyLoadView(import('@views/Setting/setting.vue')),
      meta: {
        authRequired: ROLE_AGENT,
      },
    },
  ],
}

export default settingRoutes
